import { CallIntelMocks } from '@frontend/api-call-intel';
import { useAppScopeStore } from '@frontend/scope';
import { useShowCallIntelWidgetsDemo } from './useShowCallIntelWidgetsDemo';

export const useInitCallIntelDashWidgetsDemo = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const showDemo = useShowCallIntelWidgetsDemo();

  CallIntelMocks.useCallIntelWidgetDemoInterceptors({
    enabled: showDemo,
    locationIds: selectedLocationIds,
  });
};
